<template>

	<!-- 상세본문 -->
	<div class="content board-detail" v-if="boardVO.idx > 0">
		<div class="container">
			<div class="detail-title">
				<div class="inner">
					<div class="cate bedge-line">
						<span class="prim" v-if="boardVO.cateVO != null">{{ boardVO.cateVO.codeName }}</span>
						<span class="sec" v-if="boardVO.isNotice">공지</span>
					</div>
					<h3 class="tit" style="display: flex; align-items: center">
						<span class="mr-2" v-if="boardInfoVO.isStatus && !$options.filters.isEmpty(boardVO.statusCode)"
								:class="{ 'end' : (boardVO.statusName === '완료'), 'ing' : (boardVO.statusName === '확인'), 'req' : !(boardVO.statusName === '완료' || boardVO.statusName === '확인') }">
							<span>{{ boardVO.statusName }}</span>
						</span>
						{{ boardVO.title }}
					</h3>
					<ul class="info">
						<li class="auth" v-if="!boardInfoVO.isAnonymous"><span class="blind">작성자</span>{{ boardVO.writerDec }}</li>
						<li class="date"><span class="blind">작성일</span>{{ boardVO.createDate | datetimeFilter }}</li>
						<li class="like"><span class="blind">좋아요</span>{{ boardVO.likeCount | currency }}</li>
						<li class="view"><span class="blind">조회수</span>{{ boardVO.views | currency }}</li>
					</ul>
				</div>
			</div>
			<div class="detail-content">

				<div class="attach-box" v-if="boardInfoVO.isFile && boardVO.attachList.length > 0">
					<ul>
						<li v-for="(item, index) in boardVO.attachList">
							<a @click="doDownload(item.fidx)">{{ item.filename }}</a>
						</li>
					</ul>
				</div>

<!--				<div class="inner" v-html="boardVO.contentHtml"></div>-->
				<div class="inner">
<!--					<html-open :html-code="boardVO.contentHtml"></html-open>-->
					<summernote-frame :target-id="'contentHtml-' + boardVO.idx " ref="summernote" mode="view" :html="boardVO.contentHtml"></summernote-frame>
				</div>


				<div class="like-box">
					<a href="javascript:;" class="btn-like" :class="{ 'active': (likeVO.isMine) }" @click="setLike"><span class="blind">좋아요</span>{{ boardVO.likeCount | currency }}</a>
					<a href="javascript:;" class="btn-comment" v-if="boardInfoVO.isComment" @click="goComment"><span class="blind">댓글</span>{{ boardVO.commentCount | currency }}</a>
				</div>
			</div>


			<div class="btn-area text-right m-t-10 m-b-10">
				<a href="javascript:;" class="btn btn-md" style="color:red;" @click="doCaution"> <i class="fas fa-1x fa-exclamation-triangle"></i> 신고</a>
				<a href="javascript:;" class="btn btn-md btn-outline-primary edit" v-if="isLogin() && isMine(boardVO.writerKey)" @click="goForm">수정</a>
				<a href="javascript:;" class="btn btn-md btn-outline-danger m-l-5" v-if="isLogin() && isMine(boardVO.writerKey)" @click="goDelete">삭제</a>
			</div>

			<comment-default :bidx="boardVO.idx" v-show="boardInfoVO.isComment"></comment-default>

			<!--<comment-cs1 :bidx="boardVO.idx" v-show="boardInfoVO.isComment"></comment-cs1>-->

			<div class="btn-area">
				<a href="javascript:;" class="btn-listgo" @click="goList">목록으로</a>
			</div>

		</div>
	</div>

</template>

<script>

// 대댓글 기능 없는 commentDefault , commentcs1은 대댓글 기능 있지만 제대로 동작 안함. 
import CommentDefault from "@/components/boards/comments/commentDefault";
import APIs from "@/commons/APIs";
import HWAPP from "@/commons/mixins/hwapp.mixin";
import HtmlOpen from "@/components/display/htmlOpen";

import SummernoteFrame from "@/components/display/summernoteFrame";
/*import CommentCs1 from "@/components/boards/comments/commentCs1";*/
import('summernote/dist/summernote.css')
import('summernote/dist/summernote-bs4.css')

export default {
	name: "detailDefault",
	components: {CommentDefault, SummernoteFrame, HtmlOpen},
	props: {
		boardInfoVO: Object,
		boardVO: Object,
	},
	mixins: [HWAPP],
	data() {

		return {
			// idx: this.webUtils.getParameterInt("idx"),
			idx: this.$route.query.idx,

			commentVO: new this.CommentVO( this.getSessionProc() ),
			commentList: [],

			likeVO: new this.LikeVO( this ),
		}
	},
	created() {

		// alert( this.APIs.BASE_URL )

	},
	mounted() {

		/*if ( this.idx > 0 ) {
			this.getCommentList();
		}*/
		//this.$nextTick(() => this.getLike(this.boardVO.idx, this.getLoginId()) );
	},
	updated() {

	},
	methods: {

		goList() {
			// history.back();
			this.$emit("goList");
		},


		goComment () {
			this.webUtils.scrollTo( ".detail-comment" )
		},

		goForm(e) {
			this.$emit("goForm", e, this.boardVO.idx);
			/*var queryStr = "?mode=form&idx=" + this.boardVO.idx
			location.href = location.pathname + queryStr*/
		},

		goDelete(e) {

			const self = this
			this.swalUtils.fire("삭제 하시겠습니까?", "첨부된 파일과 댓글 모두 삭제가 됩니다. 계속하시겠습니까?", "error", true )
			.then((result) => {
				if ( result.isConfirmed ) {

					self.axiosCaller.delete( this, this.APIs.BOARDS + "/deleteOne/" + self.boardVO.idx, {
						idx: self.boardVO.idx,
						userId: self.getLoginId(),
					}, (res) => {
						const result = res.data;
						if (result.status === "ok") {
							history.back()
						} else {
							console.log( result.msg )
						}
					})

				}
			})
			/*var queryStr = "?mode=form&idx=" + this.boardVO.idx
			location.href = location.pathname + queryStr*/
		},


		/**
		 * 좋아요 수 + 내 좋아요 여부 조회
		 */
		getLike ( bidx, userId ) {

			if ( bidx > 0 ) {

				this.axiosCaller.get(this, this.APIs.BOARD_LIKE + "/" + bidx + "/" + userId, {}, (res) => {
					const result = res.data
					if ( result.status === "ok" ) {
						this.boardVO.likeCount = result.likeCount
						this.likeVO = result
					}
				})
			}
		},


		setLike () {
			const self = this
			if ( !this.likeVO.isMine ) {    // 추가

				this.axiosCaller.put( this, this.APIs.BOARD_LIKE + "/" + self.boardVO.idx + "/" + self.getLoginId(), {}, (res) => {
					const result = res.data
					if ( result.status === "ok" ) {
						this.boardVO.likeCount = result.likeCount
						this.likeVO.isMine = result.isMine
					}
				})

			} else {    // 삭제

				this.axiosCaller.delete( this, this.APIs.BOARD_LIKE + "/" + self.boardVO.idx + "/" + self.getLoginId(), {},(res) => {
					const result = res.data
					if ( result.status === "ok" ) {
						this.boardVO.likeCount = result.likeCount
						this.likeVO.isMine = result.isMine
					}
				})

			}

		},



		doCaution () {

			const self = this
			self.swalUtils.fire("게시물 신고", "해당 게시물을 신고합니다.", "warning", true)
			.then( (result) => {

				if ( result.isConfirmed ) {
					const url = self.APIs.BOARD_CAUTION + "/" + self.boardVO.idx + "/" + self.getLoginId()
					self.axiosCaller.put(self, url, {}, (res) => {
						const result = res.data;
						if ( result.status === "ok" ) {

							self.swalUtils.gritter("게시물 신고", "신고되었습니다.", "info", 2000 );
							return

						} else if ( result.status === "fail" ) {
							self.swalUtils.gritter("게시물 신고", "해당게시물은 이미 신고한 계정입니다.", "info", 2000 );
							return
						}
					})
				}

			});

		},



		doDownload(fidx) {
			if (this.appDevice() === "IOS") {
				webkit.messageHandlers.iOSFileDownload.postMessage(APIs.BOARD_FILES_DOWN + '/' + fidx)
				return;
			}
			location.href = APIs.BOARD_FILES_DOWN + '/' + fidx
		}



	},
	watch: {
		'boardVO': function(newVal, oldVal) {
			/*console.log("newVal ::::: " + newVal.idx)
			console.log("oldVal ::::: " + oldVal.idx)*/
			if ( newVal.idx !== undefined && newVal.idx > 0 ) {
				//this.getCommentList();
				this.$nextTick(() => this.getLike(this.boardVO.idx, this.getLoginId()) );
			}
		},
	}
}
</script>

<style scoped>
</style>
